import { UUID } from 'angular2-uuid';
import * as moment from 'moment';
import { arrayPushUnique } from '../../../../core/util/array-push-unique';
import { Control } from '../../../../vas/business-objects/control/control.model';
import { Group } from '../../../../vas/business-objects/group/group.model';
import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';

const copyControl = (control: Control, group: string): Control => {
    return new Control({
        ...control,
        id: UUID.UUID(),
        serverCreated: '',
        serverModified: '',
        created: moment().toISOString(),
        modified: moment().toISOString(),
        group
    });
};

export const groupCopyReducer = (
    state = initialState,
    action: actions.GroupCopy
): State => {

    const group = state.group.entities[action.payload.groupId];
    const controls = Object
        .values(state.control.entities)
        .filter(c => c.group === group.id);

    const newGroupId = UUID.UUID();

    const newControls = controls
        .map(control => copyControl(control, newGroupId));

    const newControlIds = newControls.map(c => c.id);

    const newGroup: Group = new Group({
        ...group,
        id: newGroupId,
        serverCreated: '',
        serverModified: '',
        created: moment().toISOString(),
        modified: moment().toISOString(),
        visibilityControl: '',
        visibleIfEquals: '',
        controls: newControlIds,
        title: `${group.title} Copy`,
        name: `${group.name}-copy`,
        forms: []
    });

    return {
        ...state,
        dirty: true,
        dirtyIds: {
            ...state.dirtyIds,
            groups: arrayPushUnique(state.dirtyIds.groups, newGroupId),
            controls: newControlIds.reduce(
                (acc, id) => arrayPushUnique(acc, id),
                state.dirtyIds.controls
            )
        },
        group: {
            ...state.group,
            ids: [...state.group.ids, newGroupId],
            entities: {
                ...state.group.entities,
                [newGroupId]: newGroup
            }
        },
        control: {
            ...state.control,
            ids: [...state.control.ids, ...newControlIds],
            entities: {
                ...state.control.entities,
                ...newControls.reduce((p, c) => {
                    p[c.id] = c;
                    return p;
                }, {} as Record<string, Control>)
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/group-copy.reducer.ts